import { useEffect, useState, useRef } from "react";
import ArchiveMobileSearchForm from "./ArchiveMobileSearchForm";
// import MobileTransactionList from "../../transactions/MobileTransactionList";
import { ProgressBar } from "react-bootstrap";
import Api from "../../utils/Api";
import ArchiveTransactionList from "../common/ArchiveTransactionList";

export default function MobileTransactionArchive() {
    const [searchInProgress, setSearchInProgress] = useState(false);
    const [result, setResult] = useState({ items: [], sumOfTransactions: 0 });
    const [lookups, setLookups] = useState({ categories: [], tags: [] });
    const searchRef = useRef(null);
    const transactionListRef = useRef(null);

    useEffect(async () => {
        async function getData() {
            const { response: lookups } = await Api.lookups();
            setLookups(lookups);
        }

        getData();
    }, []);

    const search = async (searchData) => {
        setSearchInProgress(true);

        const params = {
            startTime: searchData.startTime,
            endTime: searchData.endTime,
            includeCategoryIds: searchData.categories,
            tagIds: searchData.tags,
            expenseOnly: false,
            incomeOnly: false,
            searchText: searchData.text,
            approvedOnly: searchData.approvedOnly,
        };

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }
        const { response } = await Api.transactionsByCategory(params);
        const { items, sumOfTransactions } = response;
        setResult({ items, sumOfTransactions });
        setSearchInProgress(false);

        if (transactionListRef) {
            transactionListRef.current?.setItems(items);
        }
    };

     const orderByAmount = () => {
        if (transactionListRef.current) {
            transactionListRef.current.orderByAmount();
        }
    };

    const listWasChanged = () => {
        searchRef?.current?.refreshSearch();
    };

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%", maxWidth: "600px" }}>
                <ArchiveMobileSearchForm
                    orderByAmount={orderByAmount}
                    searchCallback={search}
                    lookups={lookups}
                    totalSearchAmount={result.sumOfTransactions.toFixed(2)}
                    transactionCount={result.items.length}
                    ref={searchRef}
                />

                {searchInProgress ? <ProgressBar active now={100} /> : ""}

                <div style={{ marginBottom: "150px" }}>
                    <ArchiveTransactionList
                        approvalMode={true}
                        lookups={lookups}
                        ref={transactionListRef}
                        listWasChanged={listWasChanged}
                        isMobile={true}
                    />
                </div>

                {/* <div style={{ marginBottom: "150px" }}>
                    <MobileTransactionList
                        approvalMode={true}
                        lookups={lookups}
                        items={result.items}
                        ref={transactionListRef} />
                </div> */}
            </div>
        </div>
    );
}
